import script from "./PendingConfirmation.vue?vue&type=script&lang=ts&setup=true"
export * from "./PendingConfirmation.vue?vue&type=script&lang=ts&setup=true"

import "./PendingConfirmation.vue?vue&type=style&index=0&id=464fd6d2&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464fd6d2"]])

export default __exports__